import React, { useEffect, useState } from "react";
import { Row, Col, Checkbox } from "antd";
import RequestHandler from "util/RequestHandler";
import { BarsOutlined, ControlOutlined } from "@ant-design/icons";

const AccountTransactionRole = () => {
  const [tableRoles, setTableRoles] = useState({});
  const [tableRolesDigit, setTableRolesDigit] = useState({});
  const [tableRolesTenantAccount, setTableRolesTenantAccount] = useState({});
  const [tableIbanShowInColumn, setTableIbanShowInColumn] = useState({});
  const [tableRolesTenantParameter, setTableRolesTenantParameter] = useState(
    {}
  );
  const [isFull, setIsFull] = useState(false);
  const [isFullDigit, setIsFullDigit] = useState(false);
  const [isFullTenantAccount, setIsFullTenantAccount] = useState(false);
  const [isFullIbanShowInColumn, setFullIbanShowInColumn] = useState(false);
  const [isFullTenantParameter, setIsFullTenantParameter] = useState(false);

  useEffect(() => {
    loadData();
    loadDataDigit();
    loadTenantAccountData();
    loadIbanShowInColumn();
    loadTenantParameterData();
  }, []);

  const loadData = () => {
    RequestHandler.get(`/AccountTransaction/GetTransactionTableRole`).then(
      (response) => {
        if (response.success) {
          if (response.data.tenantIsKobi) {
            delete response.data.isBalanceAfterTransactionShow;
          }

          const checkboxProps = Object.keys(response.data ?? {}).filter(
            (key) =>
              key.startsWith("is") && !key.startsWith("isIbanShowInColumn")
          );
          if (
            checkboxProps.length === 0 ||
            checkboxProps.some((key) => !response.data[key])
          ) {
            setIsFull(false);
          } else {
            setIsFull(true);
          }

          setTableRoles(response.data ?? {});
        }
      }
    );
  };

  const loadDataDigit = () => {
    RequestHandler.get(`/TenantUserParameter/GetDigitParameter`).then(
      (response) => {
        if (response.success) {
          const checkboxProps = Object.keys(response.data ?? {}).filter((key) =>
            key.startsWith("isDigit")
          );
          if (
            checkboxProps.length === 0 ||
            checkboxProps.some((key) => !response.data[key])
          ) {
            setIsFullDigit(false);
          } else {
            setIsFullDigit(true);
          }

          setTableRolesDigit(response.data ?? {});
        }
      }
    );
  };
  const loadTenantAccountData = () => {
    RequestHandler.get(
      `/TenantAccountParameter/GetTenantAccountParameter`
    ).then((response) => {
      if (response.success) {
        const checkboxProps = Object.keys(response.data ?? {}).filter(
          (key) =>
            key.startsWith("isBlockedBalance") ||
            key.startsWith("isAvailableBalance") ||
            key.startsWith("isAvailableCreditBalance")
        );
        if (
          checkboxProps.length === 0 ||
          checkboxProps.some((key) => !response.data[key])
        ) {
          setIsFullTenantAccount(false);
        } else {
          setIsFullTenantAccount(true);
        }

        setTableRolesTenantAccount(response.data ?? {});
      }
    });
  };

  const loadTenantParameterData = () => {
    RequestHandler.get(`/TenantParameter/GetPosTransactionCardNumber`).then(
      (response) => {
        if (response.success) {
          const checkboxProps = Object.keys(response.data ?? {}).filter((key) =>
            key.startsWith("isPosTransactionCardNumberShowInColumn")
          );
          if (
            checkboxProps.length === 0 ||
            checkboxProps.some((key) => !response.data[key])
          ) {
            setIsFullTenantParameter(false);
          } else {
            setIsFullTenantParameter(true);
          }
          setTableRolesTenantParameter(response.data ?? {});
        }
      }
    );
  };

  const loadIbanShowInColumn = () => {
    RequestHandler.get(`/AccountTransaction/GetTransactionTableRole`).then(
      (response) => {
        if (response.success) {
          const allCheckboxProps = Object.keys(response.data ?? {}).filter(
            (key) => key.startsWith("isIbanShowInColumn")
          );

          if (
            allCheckboxProps.length === 0 ||
            allCheckboxProps.some((key) => !response.data[key])
          ) {
            setFullIbanShowInColumn(false);
          } else {
            setFullIbanShowInColumn(true);
          }

          setTableIbanShowInColumn(response.data ?? {});
        }
      }
    );
  };

  const onChangeSingle = (properyName, value) => {
    tableRoles[properyName] = value;
    RequestHandler.post(
      "/AccountTransaction/AddTransactionTableRoles",
      tableRoles
    ).then((response) => {
      if (response.success) {
        loadData();
      }
    });
  };

  const onChangeFull = (value) => {
    Object.keys(tableRoles)
      .filter(
        (key) => key.startsWith("is") && !key.startsWith("isIbanShowInColumn")
      )
      .forEach((key) => {
        tableRoles[key] = value;
      });

    RequestHandler.post(
      "/AccountTransaction/AddTransactionTableRoles",
      tableRoles
    ).then((response) => {
      if (response.success) {
        loadData();
      }
    });
  };

  const onChangeSingleTenantAccount = (properyName, value) => {
    tableRolesTenantAccount[properyName] = value;
    RequestHandler.post(
      "/TenantAccountParameter/AddTenantAccountParameter",
      tableRolesTenantAccount
    ).then((response) => {
      if (response.success) {
        loadTenantAccountData();
      }
    });
  };

  const onChangeFullTenantAccount = (value) => {
    Object.keys(tableRolesTenantAccount)
      .filter(
        (key) =>
          key.startsWith("isBlockedBalance") ||
          key.startsWith("isAvailableBalance") ||
          key.startsWith("isAvailableCreditBalance")
      )

      .forEach((key) => {
        tableRolesTenantAccount[key] = value;
      });

    RequestHandler.post(
      "/TenantAccountParameter/AddTenantAccountParameter",
      tableRolesTenantAccount
    ).then((response) => {
      if (response.success) {
        loadTenantAccountData();
      }
    });
  };

  const onChangeSingleShowIbanInColumn = (properyName, value) => {
    tableIbanShowInColumn[properyName] = value;
    RequestHandler.post(
      "/AccountTransaction/AddTransactionTableRoles",
      tableIbanShowInColumn
    ).then((response) => {
      if (response.success) {
        loadIbanShowInColumn();
      }
    });
  };

  const onChangeFullShowIbanInColumn = (value) => {
    Object.keys(tableIbanShowInColumn)
      .filter((key) => key.startsWith("isIbanShowInColumn"))
      .forEach((key) => {
        tableIbanShowInColumn[key] = value;
      });

    RequestHandler.post(
      "/AccountTransaction/AddTransactionTableRoles",
      tableIbanShowInColumn
    ).then((response) => {
      if (response.success) {
        loadIbanShowInColumn();
      }
    });
  };

  const onChangeSingleTenantParameter = (properyName, value) => {
    tableRolesTenantParameter[properyName] = value;
    RequestHandler.post(
      "/TenantParameter/UpdatePosTransactionCardNumber",
      tableRolesTenantParameter
    ).then((response) => {
      if (response.success) {
        loadTenantParameterData();
      }
    });
  };

  const onChangeFullTenantParameter = (value) => {
    Object.keys(tableRolesTenantParameter)
      .filter((key) => key.startsWith("isPosTransactionCardNumberShowInColumn"))
      .forEach((key) => {
        tableRolesTenantParameter[key] = value;
      });

    RequestHandler.post(
      "/TenantParameter/UpdatePosTransactionCardNumber",
      tableRolesTenantParameter
    ).then((response) => {
      if (response.success) {
        loadTenantParameterData();
      }
    });
  };

  const onChangeSingleDigit = (properyName, value) => {
    tableRolesDigit[properyName] = value;
    RequestHandler.post(
      "/TenantUserParameter/AddDigitParameters",
      tableRolesDigit
    ).then((response) => {
      if (response.success) {
        loadDataDigit();
      }
    });
  };

  const onChangeFullDigit = (value) => {
    Object.keys(tableRolesDigit)
      .filter((key) => key.startsWith("isDigit"))
      .forEach((key) => {
        tableRolesDigit[key] = value;
      });

    RequestHandler.post(
      "/TenantUserParameter/AddDigitParameters",
      tableRolesDigit
    ).then((response) => {
      if (response.success) {
        loadDataDigit();
      }
    });
  };

  return (
    <div>
      <Row>
        <Col
          style={{ paddingBottom: 60 }}
          xl={24}
          lg={24}
          md={24}
          sm={12}
          xs={24}
        >
          <p style={{ fontSize: "120%" }}>
            <BarsOutlined /> HESAP HAREKETLERİ KOLON PARAMETRELERİ
          </p>
        </Col>

        <Col
          style={{ textAlign: "right", marginBottom: 30 }}
          xl={12}
          lg={12}
          md={12}
          sm={12}
          xs={12}
        >
          Tümünü Seç :
        </Col>
        <Col
          style={{ textAlign: "left", marginBottom: 30 }}
          xl={12}
          lg={12}
          md={12}
          sm={12}
          xs={12}
        >
          <Checkbox
            checked={isFull}
            onChange={(e) => onChangeFull(e.target.checked)}
          />
        </Col>

        <Col xl={2} lg={2} md={2}></Col>

        <Col
          style={{ textAlign: "right", marginBottom: 10 }}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          Şube
        </Col>
        <Col style={{ textAlign: "left" }} xl={2} lg={2} md={2} sm={12} xs={12}>
          <Checkbox
            checked={tableRoles.isBranchShow}
            onChange={(e) => onChangeSingle("isBranchShow", e.target.checked)}
          />
        </Col>

        <Col
          style={{ textAlign: "right" }}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          Karşı Iban / Hesap Numarası
        </Col>
        <Col style={{ textAlign: "left" }} xl={2} lg={2} md={2} sm={12} xs={12}>
          <Checkbox
            checked={tableRoles.isIbanShow}
            onChange={(e) => onChangeSingle("isIbanShow", e.target.checked)}
          />
        </Col>
        <Col xl={6} lg={6} md={6}></Col>

        <Col xl={2} lg={2} md={2}></Col>
        <Col
          style={{ textAlign: "right", marginBottom: 10 }}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          Iban / Hesap Numarası
        </Col>
        <Col style={{ textAlign: "left" }} xl={2} lg={2} md={2} sm={12} xs={12}>
          <Checkbox
            checked={tableRoles.isTenantIbanShow}
            onChange={(e) =>
              onChangeSingle("isTenantIbanShow", e.target.checked)
            }
          />
        </Col>

        <Col
          style={{ textAlign: "right" }}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          Ek Açıklama
        </Col>
        <Col style={{ textAlign: "left" }} xl={2} lg={2} md={2} sm={12} xs={12}>
          <Checkbox
            checked={tableRoles.isAdditionalDescriptionShow}
            onChange={(e) =>
              onChangeSingle("isAdditionalDescriptionShow", e.target.checked)
            }
          />
        </Col>
        <Col xl={6} lg={6} md={6}></Col>

        <Col xl={2} lg={2} md={2}></Col>

        <Col
          className={tableRoles.tenantIsKobi ? "gx-text-light" : ""}
          style={{ textAlign: "right", marginBottom: 10 }}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          İşlem Sonrası Bakiye
        </Col>
        <Col style={{ textAlign: "left" }} xl={2} lg={2} md={2} sm={12} xs={12}>
          <Checkbox
            disabled={tableRoles.tenantIsKobi}
            checked={tableRoles.isBalanceAfterTransactionShow}
            onChange={(e) =>
              onChangeSingle("isBalanceAfterTransactionShow", e.target.checked)
            }
          />
        </Col>

        <Col
          style={{ textAlign: "right" }}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          İşlem Tipi
        </Col>
        <Col style={{ textAlign: "left" }} xl={2} lg={2} md={2} sm={12} xs={12}>
          <Checkbox
            checked={tableRoles.isTransactionTypeShow}
            onChange={(e) =>
              onChangeSingle("isTransactionTypeShow", e.target.checked)
            }
          />
        </Col>
        <Col xl={6} lg={6} md={6}></Col>
        <Col xl={2} lg={2} md={2}></Col>
        <Col
          style={{ textAlign: "right", marginBottom: 10 }}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          Cari Adı
        </Col>
        <Col style={{ textAlign: "left" }} xl={2} lg={2} md={2} sm={12} xs={12}>
          <Checkbox
            checked={tableRoles.isFirmNameShow}
            onChange={(e) => onChangeSingle("isFirmNameShow", e.target.checked)}
          />
        </Col>
        <Col
          style={{ textAlign: "right" }}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          Gönderen Adı
        </Col>
        <Col style={{ textAlign: "left" }} xl={2} lg={2} md={2} sm={12} xs={12}>
          <Checkbox
            checked={tableRoles.isSenderNameShow}
            onChange={(e) =>
              onChangeSingle("isSenderNameShow", e.target.checked)
            }
          />
        </Col>
        <Col xl={6} lg={6} md={6}></Col>
        <Col xl={2} lg={2} md={2}></Col>
        <Col
          style={{ textAlign: "right", marginBottom: 10 }}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          Döviz
        </Col>
        <Col style={{ textAlign: "left" }} xl={2} lg={2} md={2} sm={12} xs={12}>
          <Checkbox
            checked={tableRoles.isCurrencyShow}
            onChange={(e) => onChangeSingle("isCurrencyShow", e.target.checked)}
          />
        </Col>
        <Col
          style={{ textAlign: "right" }}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          Dekont No
        </Col>
        <Col style={{ textAlign: "left" }} xl={2} lg={2} md={2} sm={12} xs={12}>
          <Checkbox
            checked={tableRoles.isReceiptShow}
            onChange={(e) => onChangeSingle("isReceiptShow", e.target.checked)}
          />
        </Col>

        <Col xl={6} lg={6} md={6}></Col>

        <Col xl={2} lg={2} md={2}></Col>

        <Col
          style={{ textAlign: "right", marginBottom: 10 }}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          Açıklama
        </Col>
        <Col style={{ textAlign: "left" }} xl={2} lg={2} md={2} sm={12} xs={12}>
          <Checkbox
            checked={tableRoles.isDescriptionShow}
            onChange={(e) =>
              onChangeSingle("isDescriptionShow", e.target.checked)
            }
          />
        </Col>
        <Col
          style={{ textAlign: "right", marginBottom: 10 }}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          Vkc / T.C. No
        </Col>
        <Col style={{ textAlign: "left" }} xl={2} lg={2} md={2} sm={12} xs={12}>
          <Checkbox
            checked={tableRoles.isVknTcknShow}
            onChange={(e) => onChangeSingle("isVknTcknShow", e.target.checked)}
          />
        </Col>

        <Col xl={6} lg={6} md={6}></Col>

        <Col xl={2} lg={2} md={2}></Col>

        <Col
          style={{ textAlign: "right", marginBottom: 10 }}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          Renkli Tutar
        </Col>
        <Col style={{ textAlign: "left" }} xl={2} lg={2} md={2} sm={12} xs={12}>
          <Checkbox
            checked={tableRoles.isAmountColorful}
            onChange={(e) =>
              onChangeSingle("isAmountColorful", e.target.checked)
            }
          />
        </Col>
        <Col
          style={{ textAlign: "right", marginBottom: 10 }}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          Hesap Adı
        </Col>
        <Col style={{ textAlign: "left" }} xl={2} lg={2} md={2} sm={12} xs={12}>
          <Checkbox
            checked={tableRoles.isAccountNameShow}
            onChange={(e) =>
              onChangeSingle("isAccountNameShow", e.target.checked)
            }
          />
        </Col>

        <Col xl={6} lg={6} md={6}></Col>
        <Col xl={2} lg={2} md={2}></Col>

        <Col
          style={{ textAlign: "right", marginBottom: 10 }}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          Not
        </Col>
        <Col style={{ textAlign: "left" }} xl={2} lg={2} md={2} sm={12} xs={12}>
          <Checkbox
            checked={tableRoles.isNoteShow}
            onChange={(e) => onChangeSingle("isNoteShow", e.target.checked)}
          />
        </Col>

        <Col
          style={{ paddingBottom: 60 }}
          xl={24}
          lg={24}
          md={24}
          sm={12}
          xs={24}
        >
          <p style={{ fontSize: "120%" }}>
            <BarsOutlined /> HESAP HAREKETLERİ PARAMETRELERİ
          </p>
        </Col>
        <Col
          style={{ textAlign: "right", marginBottom: 30 }}
          xl={12}
          lg={12}
          md={12}
          sm={12}
          xs={12}
        >
          Tümünü Seç :
        </Col>
        <Col
          style={{ textAlign: "left", marginBottom: 30 }}
          xl={12}
          lg={12}
          md={12}
          sm={12}
          xs={12}
        >
          <Checkbox
            checked={isFullIbanShowInColumn}
            onChange={(e) => onChangeFullShowIbanInColumn(e.target.checked)}
          />
        </Col>

        <Col xl={2} lg={2} md={2}></Col>
        <Col
          style={{ textAlign: "right", marginBottom: 10 }}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          Karşı IBAN / Hesap Numarası
        </Col>
        <Col style={{ textAlign: "left" }} xl={1} lg={1} md={1} sm={8} xs={8}>
          <Checkbox
            checked={tableIbanShowInColumn.isIbanShowInColumn}
            onChange={(e) =>
              onChangeSingleShowIbanInColumn(
                "isIbanShowInColumn",
                e.target.checked
              )
            }
          />
        </Col>
        <Col xl={2} lg={2} md={2}></Col>
        <Col
          style={{ paddingBottom: 60 }}
          xl={24}
          lg={24}
          md={24}
          sm={12}
          xs={24}
        >
          <p style={{ fontSize: "120%" }}>
            <BarsOutlined /> EKRAN KÜSÜRAT GÖSTERİMİ
          </p>
        </Col>
        <Col
          style={{ textAlign: "right", marginBottom: 30 }}
          xl={12}
          lg={12}
          md={12}
          sm={12}
          xs={12}
        >
          Tümünü Seç :
        </Col>
        <Col
          style={{ textAlign: "left", marginBottom: 30 }}
          xl={12}
          lg={12}
          md={12}
          sm={12}
          xs={12}
        >
          <Checkbox
            checked={isFullDigit}
            onChange={(e) => onChangeFullDigit(e.target.checked)}
          />
        </Col>

        <Col xl={2} lg={2} md={2}></Col>

        <Col
          style={{ textAlign: "right", marginBottom: 10 }}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          Hesap Hareketleri Anasayfa
        </Col>
        <Col style={{ textAlign: "left" }} xl={2} lg={2} md={2} sm={12} xs={12}>
          <Checkbox
            checked={tableRolesDigit.isDigitHomePage}
            onChange={(e) =>
              onChangeSingleDigit("isDigitHomePage", e.target.checked)
            }
          />
        </Col>

        <Col
          style={{ textAlign: "right" }}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          Raporlar/Cari Durumları
        </Col>
        <Col style={{ textAlign: "left" }} xl={2} lg={2} md={2} sm={12} xs={12}>
          <Checkbox
            checked={tableRolesDigit.isDigitReportFirmStatus}
            onChange={(e) =>
              onChangeSingleDigit("isDigitReportFirmStatus", e.target.checked)
            }
          />
        </Col>
        <Col xl={6} lg={6} md={6}></Col>

        <Col xl={2} lg={2} md={2}></Col>
        <Col
          style={{ textAlign: "right", marginBottom: 10 }}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          Hesap İşlemleri/Banka Bakiyeleri
        </Col>
        <Col
          style={{ textAlign: "left", marginBottom: 10 }}
          xl={2}
          lg={2}
          md={2}
          sm={12}
          xs={12}
        >
          <Checkbox
            checked={tableRolesDigit.isDigitBankBalance}
            onChange={(e) =>
              onChangeSingleDigit("isDigitBankBalance", e.target.checked)
            }
          />
        </Col>

        <Col
          style={{ textAlign: "right", marginBottom: 10 }}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          Raporlar/Günsonu Raporu
        </Col>
        <Col
          style={{ textAlign: "left", marginBottom: 10 }}
          xl={2}
          lg={2}
          md={2}
          sm={12}
          xs={12}
        >
          <Checkbox
            checked={tableRolesDigit.isDigitReportFromEndOfDay}
            onChange={(e) =>
              onChangeSingleDigit("isDigitReportFromEndOfDay", e.target.checked)
            }
          />
        </Col>
        <Col xl={6} lg={6} md={6}></Col>

        <Col xl={2} lg={2} md={2}></Col>

        <Col
          className={tableRolesDigit.tenantIsKobi ? "gx-text-light" : ""}
          style={{ textAlign: "right", marginBottom: 10 }}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          Konsolide Raporlar
        </Col>
        <Col style={{ textAlign: "left" }} xl={2} lg={2} md={2} sm={12} xs={12}>
          <Checkbox
            checked={tableRolesDigit.isDigitConsolidate}
            onChange={(e) =>
              onChangeSingleDigit("isDigitConsolidate", e.target.checked)
            }
          />
        </Col>

        <Col
          style={{ textAlign: "right", marginBottom: 10 }}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          Raporlar/Banka Bazlı Hareket
        </Col>
        <Col style={{ textAlign: "left" }} xl={2} lg={2} md={2} sm={12} xs={12}>
          <Checkbox
            checked={tableRolesDigit.isDigitReportTransactionFromBank}
            onChange={(e) =>
              onChangeSingleDigit(
                "isDigitReportTransactionFromBank",
                e.target.checked
              )
            }
          />
        </Col>

        <Col xl={6} lg={6} md={6}></Col>

        <Col xl={2} lg={2} md={2}></Col>

        <Col
          style={{ textAlign: "right", marginBottom: 10 }}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          Raporlar/Bakiye Raporu
        </Col>
        <Col style={{ textAlign: "left" }} xl={2} lg={2} md={2} sm={12} xs={12}>
          <Checkbox
            checked={tableRolesDigit.isDigitReportFromBalance}
            onChange={(e) =>
              onChangeSingleDigit("isDigitReportFromBalance", e.target.checked)
            }
          />
        </Col>

        {/* <Col style={{ textAlign: 'right', marginBottom: 10 }} xl={6} lg={6} md={6} sm={12} xs={12}>
          Raporlar/Ay Bazlı Grafik
        </Col> */}
        {/* <Col style={{ textAlign: 'left' }} xl={2} lg={2} md={2} sm={12} xs={12}>
          <Checkbox checked={tableRolesDigit.isDigitChartFromMonth} onChange={(e) => onChangeSingleDigit("isDigitChartFromMonth", e.target.checked)} />
        </Col> */}

        <Col
          style={{ textAlign: "right" }}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          Raporlar/Tarih Bazlı Durum
        </Col>
        <Col style={{ textAlign: "left" }} xl={2} lg={2} md={2} sm={12} xs={12}>
          <Checkbox
            checked={tableRolesDigit.isDigitStatusFromDate}
            onChange={(e) =>
              onChangeSingleDigit("isDigitStatusFromDate", e.target.checked)
            }
          />
        </Col>

        <Col xl={6} lg={6} md={6}></Col>

        <Col xl={2} lg={2} md={2}></Col>

        <Col
          style={{ paddingBottom: 60 }}
          xl={24}
          lg={24}
          md={24}
          sm={12}
          xs={24}
        >
          <p style={{ fontSize: "120%" }}>
            <BarsOutlined /> POS RAPOR HAREKETLERİ KOLON GÖSTERİMİ
          </p>
        </Col>
        <Col
          style={{ textAlign: "right", marginBottom: 30 }}
          xl={12}
          lg={12}
          md={12}
          sm={12}
          xs={12}
        >
          Tümünü Seç :
        </Col>
        <Col
          style={{ textAlign: "left", marginBottom: 30 }}
          xl={12}
          lg={12}
          md={12}
          sm={12}
          xs={12}
        >
          <Checkbox
            checked={isFullTenantParameter}
            onChange={(e) => onChangeFullTenantParameter(e.target.checked)}
          />
        </Col>
        <Col xl={2} lg={2} md={2}></Col>
        <Col
          style={{ textAlign: "right", marginBottom: 10 }}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          Kart Numarası
        </Col>
        <Col style={{ textAlign: "left" }} xl={1} lg={1} md={1} sm={8} xs={8}>
          <Checkbox
            checked={
              tableRolesTenantParameter.isPosTransactionCardNumberShowInColumn
            }
            onChange={(e) =>
              onChangeSingleTenantParameter(
                "isPosTransactionCardNumberShowInColumn",
                e.target.checked
              )
            }
          />
        </Col>

        <Col xl={2} lg={2} md={2}></Col>

        <Col
          style={{ paddingBottom: 60 }}
          xl={24}
          lg={24}
          md={24}
          sm={12}
          xs={24}
        >
          <p style={{ fontSize: "120%" }}>
            <BarsOutlined /> POS TAHSİLAT DEKONT GÖNDERİMİ
          </p>
        </Col>

        <Col xl={2} lg={2} md={2}></Col>

        <Col
          style={{ textAlign: "right", marginBottom: 10 }}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          Mail ile gönder
        </Col>

        <Col style={{ textAlign: "left" }} xl={2} lg={2} md={2} sm={12} xs={12}>
          <Checkbox
            checked={tableRolesDigit.isReceiptMailSend}
            onChange={(e) =>
              onChangeSingleDigit("isReceiptMailSend", e.target.checked)
            }
          />
        </Col>

        <Col
          style={{ paddingBottom: 60 }}
          xl={24}
          lg={24}
          md={24}
          sm={12}
          xs={24}
        >
          <p style={{ fontSize: "120%" }}>
            <BarsOutlined /> HESAP PARAMETRELERİ
          </p>
        </Col>
        <Col
          style={{ textAlign: "right", marginBottom: 30 }}
          xl={12}
          lg={12}
          md={12}
          sm={12}
          xs={12}
        >
          Tümünü Seç :
        </Col>
        <Col
          style={{ textAlign: "left", marginBottom: 30 }}
          xl={12}
          lg={12}
          md={12}
          sm={12}
          xs={12}
        >
          <Checkbox
            checked={isFullTenantAccount}
            onChange={(e) => onChangeFullTenantAccount(e.target.checked)}
          />
        </Col>

        <Col xl={2} lg={2} md={2}></Col>

        <Col
          style={{ textAlign: "right", marginBottom: 10 }}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          Blokeli Bakiye
        </Col>
        <Col style={{ textAlign: "left" }} xl={1} lg={1} md={1} sm={8} xs={8}>
          <Checkbox
            checked={tableRolesTenantAccount.isBlockedBalance}
            onChange={(e) =>
              onChangeSingleTenantAccount("isBlockedBalance", e.target.checked)
            }
          />
        </Col>

        <Col
          style={{ textAlign: "right" }}
          xl={3}
          lg={3}
          md={3}
          sm={14}
          xs={14}
        >
          Kullanılabilir Bakiye
        </Col>
        <Col style={{ textAlign: "left" }} xl={1} lg={1} md={1} sm={8} xs={8}>
          <Checkbox
            checked={tableRolesTenantAccount.isAvailableBalance}
            onChange={(e) =>
              onChangeSingleTenantAccount(
                "isAvailableBalance",
                e.target.checked
              )
            }
          />
        </Col>

        <Col
          style={{ textAlign: "right" }}
          xl={3}
          lg={3}
          md={3}
          sm={14}
          xs={14}
        >
          Kredili Kullanılabilir Bakiye
        </Col>
        <Col style={{ textAlign: "left" }} xl={1} lg={1} md={1} sm={8} xs={8}>
          <Checkbox
            checked={tableRolesTenantAccount.isAvailableCreditBalance}
            onChange={(e) =>
              onChangeSingleTenantAccount(
                "isAvailableCreditBalance",
                e.target.checked
              )
            }
          />
        </Col>

        {/* <Col xl={2} lg={2} md={2}></Col> */}

        <Col
          style={{ paddingBottom: 60 }}
          xl={24}
          lg={24}
          md={24}
          sm={12}
          xs={24}
        >
          <p style={{ fontSize: "120%" }}>
            <BarsOutlined /> ANASAYFA BAKİYE GÖSTERİMİ
          </p>
        </Col>

        <Col xl={2} lg={2} md={2}></Col>

        <Col
          style={{ textAlign: "right", marginBottom: 10 }}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          Kullanılabilir Bakiye
        </Col>

        <Col style={{ textAlign: "left" }} xl={2} lg={2} md={2} sm={12} xs={12}>
          <Checkbox
            checked={tableRolesDigit.isHomePageAvailableBalance}
            onChange={(e) =>
              onChangeSingleDigit(
                "isHomePageAvailableBalance",
                e.target.checked
              )
            }
          />
        </Col>
      </Row>
    </div>
  );
};
export default AccountTransactionRole;
